import { ClientEvent } from '@udemy/event-tracking';
export class LearningPathSelected extends ClientEvent {
  constructor(learningPath, uiRegion, topicIds, searchTrackingId, serveTrackingId) {
    super('LearningPathSelected');
    this.learningPath = learningPath;
    this.uiRegion = uiRegion;
    this.topicIds = topicIds;
    this.searchTrackingId = searchTrackingId;
    this.serveTrackingId = serveTrackingId;
    this.learningPath = learningPath;
    this.uiRegion = uiRegion;
    this.topicIds = topicIds;
    this.searchTrackingId = searchTrackingId;
    this.serveTrackingId = serveTrackingId;
  }
}
export class LearningPathPresented extends ClientEvent {
  constructor(learningPath, uiRegion, topicIds, searchTrackingId, serveTrackingId) {
    super('LearningPathPresented');
    this.learningPath = learningPath;
    this.uiRegion = uiRegion;
    this.topicIds = topicIds;
    this.searchTrackingId = searchTrackingId;
    this.serveTrackingId = serveTrackingId;
    this.learningPath = learningPath;
    this.uiRegion = uiRegion;
    this.topicIds = topicIds;
    this.searchTrackingId = searchTrackingId;
    this.serveTrackingId = serveTrackingId;
  }
}

/* istanbul ignore next */
export class LearningPathUnenrolled extends ClientEvent {
  constructor(learningPath, userIsLearningPathEditor) {
    super('LearningPathUnenrolled');
    this.learningPath = learningPath;
    this.userIsLearningPathEditor = userIsLearningPathEditor;
    this.learningPath = learningPath;
    this.userIsLearningPathEditor = userIsLearningPathEditor;
  }
}

/* istanbul ignore next */
export class ExploreLearningPathsSelected extends ClientEvent {
  constructor(uiRegion) {
    super('ExploreLearningPathsSelected');
    this.uiRegion = uiRegion;
    this.uiRegion = uiRegion;
  }
}
//# sourceMappingURL=events.js.map